import useFetch from '@hooks/useFetch';

const useCancelReasons = (sessionUID) => {
  const key = `v1/live_interaction/session/${sessionUID}/cancel_reasons/`;
  const { data = [], ...rest } = useFetch(
    sessionUID ? key : null,
    {},
    {
      revalidateOnMount: true
    }
  );

  return { cancelReasonsInfo: data, ...rest };
};

export default useCancelReasons;
